// extracted by mini-css-extract-plugin
export default {"title-section":"YJgb","titleSection":"YJgb","tabs":"fiR4"};